import { useNavigate } from 'react-router-dom';
import { Button } from 'Views/Components/Button/Button';
import { FormattedMessage } from 'react-intl';
import * as React from 'react';
import useDeviceDetect from 'Hooks/useDeviceDetect';
import { trackStartGuidedBooking } from 'Util/_HumanWritten/Analytics/analyticsEvents';
import { TabSelected } from '../BookingWizard/FerryTripBookingWizard/BookingWizardTypes';

export interface VehicleBookingButtonProps {
	onSearch: (type: TabSelected) => void;
}

export function VehicleBookingButton({ onSearch }: VehicleBookingButtonProps) {
	const navigate = useNavigate();
	const { isMobile } = useDeviceDetect();

	const onVehicleClick = () => {
		trackStartGuidedBooking('vehicle');
		onSearch('vehicle');

		if (isMobile) {
			navigate('/booking-wizard?type=vehicle');
		} else {
			navigate('/home/search?type=cargo');
		}
	};

	const cargoIcon = (
		<span className="material-symbols-outlined cargo__icon" style={{ color: 'black' }}>
			directions_car
		</span>
	);

	return (
		<Button key="vehicle-booking-button" className="booking-type__button hide-underline" onClick={onVehicleClick}>
			<h5>
				{cargoIcon}
				<FormattedMessage id="vehicle__name__label" defaultMessage="Cargo" />
			</h5>
		</Button>
	);
}
